"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _debug = _interopRequireDefault(require("debug"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _paths = require("../../utils/paths");
var _ErrorBoundary = _interopRequireDefault(require("../ErrorBoundary"));
var _APINavigationDisabled = _interopRequireDefault(require("./APINavigationDisabled"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var log = (0, _debug.default)('apiconsole:components:apinavigation');
var APINavigation = exports.default = /*#__PURE__*/function (_React$Component) {
  function APINavigation() {
    var _this;
    (0, _classCallCheck2.default)(this, APINavigation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, APINavigation, [].concat(args));
    (0, _defineProperty2.default)(_this, "onAPINavigationSelectionChangedEvent", function (event) {
      log('onAPINavigationSelectionChangedEvent', event.detail);
      event.preventDefault();
      if (event.detail.selected && event.detail.type) {
        _this.onSelectionChanged(event.detail.selected, event.detail.type);
      }
    });
    (0, _defineProperty2.default)(_this, "onSelectionChanged", function (selected, nodeType) {
      var _this$context = _this.context,
        getPath = _this$context.getPath,
        push = _this$context.push;
      var _this$props = _this.props,
        asset = _this$props.asset,
        isDraft = _this$props.isDraft,
        isVersionNavigation = _this$props.isVersionNavigation;
      var type = asset.type,
        groupId = asset.groupId,
        assetId = asset.assetId,
        version = asset.version,
        minorVersion = asset.minorVersion,
        organization = asset.organization;
      var consolePath = getPath('console', {
        type: type,
        groupId: groupId,
        assetId: assetId,
        version: version,
        minorVersion: minorVersion,
        organization: organization,
        consolePath: (0, _paths.getConsolePathForSelection)(nodeType, selected),
        isDraft: isDraft,
        isVersionNavigation: isVersionNavigation
      });
      return push(consolePath);
    });
    return _this;
  }
  (0, _inherits2.default)(APINavigation, _React$Component);
  return (0, _createClass2.default)(APINavigation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.navElement) {
        return;
      }
      this.navElement.addEventListener('api-navigation-selection-changed', this.onAPINavigationSelectionChangedEvent);
      if (this.props.selected) {
        this.navElement.selected = this.props.selected;
      }
      if (this.props.selectedType) {
        this.navElement.selectedType = this.props.selectedType;
      }
      if (this.props.rearrangeEndpoints) {
        this.navElement.rearrangeEndpoints = this.props.rearrangeEndpoints;
      }
      if (this.props.renderFullPaths) {
        this.navElement.renderFullPaths = this.props.renderFullPaths;
      }
      if (this.props.amfValue) {
        this.navElement.amfModel = this.props.amfValue;
        this.navElement.amf = this.props.amfValue;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (!this.navElement) {
        return;
      }
      if (prevProps.selected !== this.props.selected) {
        this.navElement.selected = this.props.selected;
      }
      if (prevProps.selectedType !== this.props.selectedType) {
        this.navElement.selectedType = this.props.selectedType;
      }
      if (prevProps.rearrangeEndpoints !== this.props.rearrangeEndpoints) {
        this.navElement.rearrangeEndpoints = this.props.rearrangeEndpoints;
      }
      if (prevProps.renderFullPaths !== this.props.renderFullPaths) {
        this.navElement.renderFullPaths = this.props.renderFullPaths;
      }
      if (prevProps.amfValue !== this.props.amfValue || !this.navElement.amfModel) {
        this.navElement.amfModel = this.props.amfValue;
        this.navElement.amf = this.props.amfValue;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.navElement) {
        return;
      }
      this.navElement.removeEventListener('api-navigation-selection-changed', this.onAPINavigationSelectionChangedEvent);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        isEdit = _this$props2.isEdit,
        error = _this$props2.error;
      if (isEdit || error) {
        return /*#__PURE__*/_react.default.createElement(_APINavigationDisabled.default, {
          isEdit: isEdit,
          error: error
        });
      }
      return /*#__PURE__*/_react.default.createElement(_ErrorBoundary.default, {
        message: "We can't load the API console"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "apic-container"
      }, /*#__PURE__*/_react.default.createElement("api-navigation", {
        summary: true,
        endpointsopened: true,
        "endpoints-opened": true,
        compatibility: true,
        noink: true,
        ref: function ref(element) {
          _this2.navElement = element;
        }
      })));
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(APINavigation, "propTypes", {
  amfValue: _propTypes.default.array,
  asset: _propTypes.default.any,
  isDraft: _propTypes.default.bool,
  isEdit: _propTypes.default.bool,
  rearrangeEndpoints: _propTypes.default.bool,
  renderFullPaths: _propTypes.default.bool,
  isVersionNavigation: _propTypes.default.bool,
  error: _propTypes.default.object,
  selected: _propTypes.default.string,
  selectedType: _propTypes.default.string
});
(0, _defineProperty2.default)(APINavigation, "contextType", _exchangeReactHooks.RouterContext);
//# sourceMappingURL=APINavigation.js.map